export default "__VITE_ASSET__CKS3Ls86__"